module.exports = __webpack_public_path__ + "img/maxDiscountPercentage.f11cf113.svg";